import * as Yup from "yup";

import { EMAIL_REGEX } from "utils/constants";

export const validationSchema = Yup.object({
  companyName: Yup.string().trim().required("Please fill out this field.").max(100, "Maximum 100 characters."),
  emirate: Yup.string().required("Please choose an option."),
  fullName: Yup.string().trim().required("Please fill out this field.").max(100, "Maximum 100 characters."),
  email: Yup.string().required("Please fill out this field.").matches(EMAIL_REGEX, "Invalid email format."),
  position: Yup.string().trim().max(100, "Maximum 100 characters."),
  phoneNumber: Yup.string().required("Please fill out this field.").min(6, "Please fill out this field."),
});

export const editValidationSchema = Yup.object({
  companyName: Yup.string().trim().required("Please fill out this field.").max(100, "Maximum 100 characters."),
  emirate: Yup.string().required("Please choose an option."),
});
